import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '.../../../components/Modal';
import { throttle } from 'lodash-es';
import Manipulator from '../../../utils/dom/manipulator';

const SELECTOR_WRAPPER = '.p-coach-learning-journey-edit-textarea';
const SELECTOR_MODAL = '.js-coach-learning-journey-modal';

const SELECTOR_VALIDATION_WRAPPER = '.validation-wrapper';
const SELECTOR_TEXTAREA = '.p-coach-learning-journey-textarea';

const SELECTOR_MINLIMIT = '#textarea-counter__minimum';
const SELECTOR_CURRENT_COUNTER = '#textarea-counter__current';

const SELECTOR_NEXT_BUTTON = '.lta-form-generator__form-next';

const SELECTOR_EXIT_BUTTON = '.js-exit-coach-learning-journey';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-coach-learning-journey-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-coach-learning-journey-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-coach-learning-journey-confirm-no';

const EVENT_KEY_COUNTER = `.lta.textareacounter`;
const EVENT_KEYUP_COUNTER = `keyup.${EVENT_KEY_COUNTER}`;

class CoachesLearningJourneyEditTextarea {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}

		this.init();
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();

		this.textArea = SelectorEngine.findOne(SELECTOR_TEXTAREA, this._wrapper);
		this.validationWrappaer = SelectorEngine.findOne(SELECTOR_VALIDATION_WRAPPER, this._wrapper);
		this.validationErrorText = SelectorEngine.findOne('.lta-text-input--error', this.validationWrappaer);
		this.minLimit = SelectorEngine.findOne(SELECTOR_MINLIMIT, this._wrapper);
		this.currentCounter = SelectorEngine.findOne(SELECTOR_CURRENT_COUNTER, this._wrapper);
		this.currentCounter.innerHTML = this.minLimit.textContent;

		const errorMessage =
			Manipulator.getDataAttribute(this._wrapper, 'validation-message') ||
			'Please input an answer above 250 characters';

		console.log(this.textArea.textContent.length);

		EventHandler.on(
			this.textArea,
			EVENT_KEYUP_COUNTER,
			throttle(() => {
				this.counterContentUpdate();
			}, 200)
		);

		this.nextButton = SelectorEngine.findOne(SELECTOR_NEXT_BUTTON, this._wrapper);

		EventHandler.on(this.nextButton, Events.Click, () => {
			if (this.currentCounter.innerHTML > 0) {
				this.validationErrorText.textContent = errorMessage;
				this.validationWrappaer.classList.add('validation-error');
			} else {
				this.validationErrorText.textContent = '';
				this.validationWrappaer.classList.remove('validation-error');
			}
		});

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.initEventHandlers();
	}

	counterContentUpdate() {
		const limit = this.minLimit.textContent ? this.minLimit.textContent : 250;

		if (this.textArea?.textContent.length >= 0) {
			if (limit - this.textArea?.value.length >= 0) {
				this.currentCounter.innerHTML = limit - this.textArea?.value.length;
			} else {
				this.currentCounter.innerHTML = 0;
			}
		}
	}

	initEventHandlers() {
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalCoachesLearningJourneyEditTextarea = new CoachesLearningJourneyEditTextarea();
export default globalCoachesLearningJourneyEditTextarea;
